import { UserGroup } from '@/DTOS/UserGroup/Response/UserGroup';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { EditOutlined } from '@ant-design/icons';

export const UserGroupColumn = (handleEdit: (record: UserGroup) => void) => [
 
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Supervizori',
    dataIndex: 'supervisors',
    key: 'supervisors',
    render: (supervisors: any[]) =>
      supervisors
        ?.map((supervisor) => supervisor.user?.name)
        .filter(Boolean)
        .join(', ') || '-',
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    render: (record: boolean) => (record ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: any) =>
    <Tooltip title='Modifica'> 
    <Button icon={<EditOutlined />} onClick={() => handleEdit(record)} ></Button>
    </Tooltip>,
    width: 120,
    fixed:'right',
  },


];
